import React from 'react';
import './SearchPage.css';

const SearchPage = () => (
  <div className="search-fill">
    <i className="fa-solid fa-magnifying-glass"></i>
    <h2>No search results found.</h2>
    <p>
      Try again with a different spelling or combination of words. Full words often produce
      the best results.
    </p>
    <div className="cry">
      <i className="fa-solid fa-face-sad-cry"></i>
      <i className="fa-solid fa-face-sad-cry"></i>
    </div>
  </div>
);

export default SearchPage;
